function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 3,
  fill: "#FFE58A"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.638 5.406c-1.078 1.937-.195 3.489.102 3.92-.362.704-.64 1.48-.737 2.293-.023.185.101.355.277.378a.268.268 0 00.04.003.327.327 0 00.317-.296c.322-2.688 2.956-5.035 3.343-5.367.101-.023.29-.033.384.176.076.167.026.284.006.32-1.614 1.618-2.315 2.733-2.026 3.225.06.102.172.16.282.16 1.173-.04 2.058-.483 2.633-1.32 1.37-1.996.428-5.506.387-5.654a.329.329 0 00-.227-.233.308.308 0 00-.305.087c-.567.593-1.261.721-1.996.856-.916.168-1.862.341-2.48 1.452z",
  fill: "#005646"
});

function SvgLocal2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgLocal2;